const NetworkPermissions = {
  edit: 'network:edit',
  create: 'network:create',
  delete: 'network:delete',
  view: 'network:view',
}

export default NetworkPermissions
